import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Counter from "../../../Tool/Counter/Counter";
import ColorPicker from "../../../Tool/ColorPicker/ColorPicker";
import cloneDeep from "lodash.clonedeep";
import * as UTILS from "../../../../utils/Utils";
import * as actionTypes from "../../../../store/Actions/actions";
import RangeInputSlider from "../../../Tool/RangeSlider";
import UnitSelector from "../../../Tool/UnitSelector/UnitSelector";
import ImagesContent from "../../../Modal/Library/Content/ImagesContent";

import { TabContent, TabPane } from "reactstrap";
import Axios from "../../../../axios";

const cropper = React.createRef(null);
let croppedImage = null;
class RowBg extends Component {
  constructor(props) {
    super(props);
    this.state = {
      src: null,
      clickedID: null,
      image: null,
      cropImage: null,
      croppedImage: null,
      bgColorPicker: false,
      mobileGutter: false,
      toggleBackgroundSettings: false,
    };
  }
  componentDidMount = () => {
    // this.setState({
    //   mobileGutter: this.props.gutterSpaceBtwnColMobile > 0 || this.props.gutterSpaceBtwnColMobile > "0" ? true : false
    // })
  };

  addBg = () => {
    this.setState({
      clickedID: this.state.clickedID == null ? this.props.ID : null,
      cropImage: null,
      image: null,
      croppedImage: null,
    });
  };
  editImage = () => {
    this.setState({
      cropImage: this.state.image.image,
    });
  };
  bgColorhandleChange = (e, property) => {
    let newColor = e.rgb;
    let layout = JSON.parse(JSON.stringify(this.props.layout));

    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        !("rowStyle" in item) && (item.rowStyle = {});
        item.rowStyle[property] = newColor;
      },
      (colItem) => {
        !("rowStyle" in colItem) && (colItem.rowStyle = {});
        colItem.rowStyle[property] = newColor;
      },
      (colItemNested) => {
        !("rowStyle" in colItemNested) && (colItemNested.rowStyle = {});
        colItemNested.rowStyle[property] = newColor;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  selectImage = (image) => {
    const layout = cloneDeep(this.props.layout);
    const selectedImage = image.image_thumb;

    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        !("rowStyle" in item) && (item.rowStyle = {});
        item.rowStyle.rowBg = selectedImage;
        item.rowStyle.croppedBg = null;
      },
      (colItem) => {
        !("rowStyle" in colItem) && (colItem.rowStyle = {});
        colItem.rowStyle.rowBg = selectedImage;
        colItem.rowStyle.croppedBg = null;
      },
      (colItemNested) => {
        !("rowStyle" in colItemNested) && (colItemNested.rowStyle = {});
        colItemNested.rowStyle.rowBg = selectedImage;
        colItemNested.rowStyle.croppedBg = null;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  resetBackground = () => {
    const layout = cloneDeep(this.props.layout);
    const selectedImage = this.state.croppedImage;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        !("rowStyle" in item) && (item.rowStyle = {});
        item.rowStyle.croppedBg = null;
        item.rowStyle.rowBg = null;
        item.rowStyle.rowBgColor = null;
      },
      (colItem) => {
        !("rowStyle" in colItem) && (colItem.rowStyle = {});
        colItem.rowStyle.croppedBg = null;
        colItem.rowStyle.rowBg = null;
        colItem.rowStyle.rowBgColor = null;
      },
      (colItemNested) => {
        !("rowStyle" in colItemNested) && (colItemNested.rowStyle = {});
        colItemNested.rowStyle.croppedBg = null;
        colItemNested.rowStyle.rowBg = null;
        colItemNested.rowStyle.rowBgColor = null;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
    // this.props.closeModal();
  };
  cropImage = () => {
    const dataUrl = this.cropper.getCroppedCanvas().toDataURL();
    this.setState({
      croppedImage: dataUrl,
    });
  };

  convertBase64Image = () => {
    let base64ContentArray = this.state.croppedImage.split(",");
    let mimeType = this.state.croppedImage.match(
      /[^:\s*]\w+\/[\w-+\d.]+(?=[;| ])/
    )[0];
    let imageExt = mimeType.substr(mimeType.lastIndexOf("/") + 1);
    let base64Data = base64ContentArray[1];
    const data = {
      u: this.props.userID,
      sn: this.props.sessionID,
      tp: "base64",
      ext: imageExt,
      fullsize: base64Data,
    };
    Axios.MediaService.POST_MEDIA(data)
      .then((response) => {
        this.cropAndApplyImage(response.data.srcUrl);
        if (response.status == 200) {
          this.setState({
            loading: false,
            cropImage: null,
          });
        }
      })
      .catch((error) => {
        // Error
      });
  };
  cropAndApplyImage = (image) => {
    const layout = cloneDeep(this.props.layout);
    // const selectedImage = this.state.croppedImage;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        !("rowStyle" in item) && (item.rowStyle = {});
        item.rowStyle.croppedBg = image;
        item.rowStyle.rowBg = null;
      },
      (colItem) => {
        !("rowStyle" in colItem) && (colItem.rowStyle = {});
        colItem.rowStyle.croppedBg = image;
        colItem.rowStyle.rowBg = null;
      },
      (colItemNested) => {
        !("rowStyle" in colItemNested) && (colItemNested.rowStyle = {});
        colItemNested.rowStyle.croppedBg = image;
        colItemNested.rowStyle.rowBg = null;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
    this.props.closeModal();
  };

  getImage = (image) => {
    this.setState({
      image: image,
    });
  };
  resetMobileGutterSpace = () => {
    const layout = cloneDeep(this.props.layout);
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        !("rowStyle" in item) && (item.rowStyle = {});
        item.rowStyle.gutterSpaceBtwnColMobile = "0";
      },
      (colItem) => {
        !("rowStyle" in colItem) && (colItem.rowStyle = {});
        colItem.rowStyle.gutterSpaceBtwnColMobile = "0";
      },
      (colItemNested) => {
        !("rowStyle" in colItemNested) && (colItemNested.rowStyle = {});
        colItemNested.rowStyle.gutterSpaceBtwnColMobile = "0";
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
    this.setState({
      mobileGutter: false,
    });
  };
  counterChange = (e, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue =
      e.target.value !== "" && e.target.value !== "0" && e.target.value !== "00"
        ? e.target.value.replace(/\b0+/g, "")
        : "0";
    let columnNumber = this.props.ColumnNumber;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        !("rowStyle" in item) && (item.rowStyle = {});
        item.rowStyle[property] = selectedValue;
      },
      (colItem) => {
        !("rowStyle" in colItem) && (colItem.rowStyle = {});
        colItem.rowStyle[property] = selectedValue;
      },
      (colItemNested) => {
        !("rowStyle" in colItemNested) && (colItemNested.rowStyle = {});
        colItemNested.rowStyle[property] = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  counterPlus = (value, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = value;
    let columnNumber = this.props.ColumnNumber;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        !("rowStyle" in item) && (item.rowStyle = {});
        item.rowStyle[property] = JSON.stringify(JSON.parse(selectedValue) + 1);
      },
      (colItem) => {
        !("rowStyle" in colItem) && (colItem.rowStyle = {});
        colItem.rowStyle[property] = JSON.stringify(
          JSON.parse(selectedValue) + 1
        );
      },
      (colItemNested) => {
        !("rowStyle" in colItemNested) && (colItemNested.rowStyle = {});
        colItemNested.rowStyle[property] = JSON.stringify(
          JSON.parse(selectedValue) + 1
        );
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  counterMinus = (value, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = value > 1 ? value : "1";
    let columnNumber = this.props.ColumnNumber;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        !("rowStyle" in item) && (item.rowStyle = {});
        item.rowStyle[property] = JSON.stringify(JSON.parse(selectedValue) - 1);
      },
      (colItem) => {
        !("rowStyle" in colItem) && (colItem.rowStyle = {});
        colItem.rowStyle[property] = JSON.stringify(
          JSON.parse(selectedValue) - 1
        );
      },
      (colItemNested) => {
        !("rowStyle" in colItemNested) && (colItemNested.rowStyle = {});
        colItemNested.rowStyle[property] = JSON.stringify(
          JSON.parse(selectedValue) - 1
        );
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  unitValueChange = (e, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = e.target.value;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        !("rowStyle" in item) && (item.rowStyle = {});
        item.rowStyle[property] = selectedValue;
      },
      (colItem) => {
        !("rowStyle" in colItem) && (colItem.rowStyle = {});
        colItem.rowStyle[property] = selectedValue;
      },
      (colItemNested) => {
        !("rowStyle" in colItemNested) && (colItemNested.rowStyle = {});
        colItemNested.rowStyle[property] = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  rangeWidthSlider = (width) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue =
      width !== "" && width !== "0" && width !== "00"
        ? width.replace(/\b0+/g, "")
        : "0";

    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.rowStyle.opacity = selectedValue;
      },
      (colItem) => {
        colItem.rowStyle.opacity = selectedValue;
      },
      (colItemNested) => {
        colItemNested.rowStyle.opacity = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  bgRepeat = (e) => {
    let layout = JSON.parse(JSON.stringify(this.props.layout));

    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        !("rowStyle" in item) && (item.rowStyle = {});
        item.rowStyle.bgRepeat = e.target.checked ? "repeat" : "no-repeat";
        item.rowStyle.bgSize = e.target.checked ? "auto" : item.rowStyle.bgSize;
      },
      (colItem) => {
        !("rowStyle" in colItem) && (colItem.rowStyle = {});
        colItem.rowStyle.bgRepeat = e.target.checked ? "repeat" : "no-repeat";
        colItem.rowStyle.bgSize = e.target.checked
          ? "auto"
          : colItem.rowStyle.bgSize;
      },
      (colItemNested) => {
        !("rowStyle" in colItemNested) && (colItemNested.rowStyle = {});
        colItemNested.rowStyle.bgRepeat = e.target.checked
          ? "repeat"
          : "no-repeat";
        colItemNested.rowStyle.bgSize = e.target.checked
          ? "auto"
          : colItemNested.rowStyle.bgSize;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  bgSize = (e) => {
    let layout = JSON.parse(JSON.stringify(this.props.layout));

    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        !("rowStyle" in item) && (item.rowStyle = {});
        item.rowStyle.bgSize = e.target.checked ? "cover" : "auto";
        item.rowStyle.bgRepeat = e.target.checked ? "no-repeat" : "repeat";
      },
      (colItem) => {
        !("rowStyle" in colItem) && (colItem.rowStyle = {});
        colItem.rowStyle.bgSize = e.target.checked ? "cover" : "auto";
        colItem.rowStyle.bgRepeat = e.target.checked ? "no-repeat" : "repeat";
      },
      (colItemNested) => {
        !("rowStyle" in colItemNested) && (colItemNested.rowStyle = {});
        colItemNested.rowStyle.bgSize = e.target.checked ? "cover" : "auto";
        colItemNested.rowStyle.bgRepeat = e.target.checked
          ? "no-repeat"
          : "repeat";
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  rowLabelInput = (e) => {
    let layout = JSON.parse(JSON.stringify(this.props.layout));
    //
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.label = e.target.value;
      },
      (item) => {
        item.label = e.target.value;
      },
      (item) => {
        item.label = e.target.value;
      }
    );
    //
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  rowNameInput = (e) => {
    let layout = JSON.parse(JSON.stringify(this.props.layout));
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.name = e.target.value;
      },
      (item) => {
        item.name = e.target.value;
      },
      (item) => {
        item.name = e.target.value;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  render() {
    //
    return (
      <div className="modalScrollContainerSecondary">
        <div className="rowBgSectionMain" style={{ paddingTop: "0" }}>
          {this.props.dataModule ? null : (
            <React.Fragment>
              <div className="modalContentWrapper">
                <label htmlFor="row-name">Row Name</label>
                <div style={{ display: "flex", gap: "20px" }}>
                  <input
                    onChange={(e) => {
                      this.rowNameInput(e);
                    }}
                    defaultValue={this.props.name}
                    className="row-label-input"
                    id="row-name"
                    placeholder="Add Row Name"
                    type="text"
                  />
                </div>
              </div>
              <div className="modalContentWrapper">
                <label htmlFor="row-label">
                  Row Label <small> (For Meta Data and Aria Labels)</small>
                </label>
                <div style={{ display: "flex", gap: "20px" }}>
                  <input
                    onChange={(e) => {
                      this.rowLabelInput(e);
                    }}
                    defaultValue={this.props.label}
                    className="row-label-input"
                    id="row-label"
                    placeholder="Add Row Label"
                    type="text"
                  />
                </div>
              </div>
              <div className="wrap padding-section">
                <div
                  className="padding-section"
                  style={{ marginBottom: "5px" }}
                >
                  <div className="heading">Row Padding</div>
                </div>

                <div
                  className="heading-row modalContentWrapper"
                  style={{ justifyContent: "flex-end" }}
                >
                  <UnitSelector
                    value={
                      this.props.rowStyle && this.props.rowStyle.paddingUnit
                        ? this.props.rowStyle.paddingUnit
                        : "px"
                    }
                    onChange={(e) => {
                      this.unitValueChange(e, "paddingUnit");
                    }}
                  />
                </div>

                <div
                  className="d-flex modalContentWrapper"
                  style={{ columnGap: "5px" }}
                >
                  <div style={{ width: "50%" }}>
                    <div className="heading-row">Desktop</div>
                    <div className="options">
                      <div className="d-block">
                        <Counter
                          label="Top"
                          small={
                            this.props.rowStyle &&
                            this.props.rowStyle.paddingUnit === "%"
                              ? "percent"
                              : "pixel"
                          }
                          minusClick={() =>
                            this.counterMinus(
                              this.props.rowStyle &&
                                this.props.rowStyle.paddingTop
                                ? this.props.rowStyle.paddingTop
                                : "0",
                              "paddingTop"
                            )
                          }
                          valueContent={
                            this.props.rowStyle &&
                            this.props.rowStyle.paddingTop
                              ? this.props.rowStyle.paddingTop
                              : "0"
                          }
                          disabled={false}
                          onChange={(e) => {
                            this.counterChange(e, "paddingTop");
                          }}
                          plusClick={() => {
                            this.counterPlus(
                              this.props.rowStyle &&
                                this.props.rowStyle.paddingTop
                                ? this.props.rowStyle.paddingTop
                                : "0",
                              "paddingTop"
                            );
                          }}
                        />
                      </div>
                      <div className="d-block">
                        <Counter
                          label="Bottom"
                          small={
                            this.props.rowStyle &&
                            this.props.rowStyle.paddingUnit === "%"
                              ? "percent"
                              : "pixel"
                          }
                          minusClick={() =>
                            this.counterMinus(
                              this.props.rowStyle &&
                                this.props.rowStyle.paddingBottom
                                ? this.props.rowStyle.paddingBottom
                                : "0",
                              "paddingBottom"
                            )
                          }
                          valueContent={
                            this.props.rowStyle &&
                            this.props.rowStyle.paddingBottom
                              ? this.props.rowStyle.paddingBottom
                              : "0"
                          }
                          disabled={false}
                          onChange={(e) => {
                            this.counterChange(e, "paddingBottom");
                          }}
                          plusClick={() =>
                            this.counterPlus(
                              this.props.rowStyle &&
                                this.props.rowStyle.paddingBottom
                                ? this.props.rowStyle.paddingBottom
                                : "0",
                              "paddingBottom"
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div style={{ width: "50%" }}>
                    <div className="heading-row">Mobile</div>
                    <div className="options">
                      <div className="d-block">
                        <Counter
                          label="Top"
                          small={
                            this.props.rowStyle &&
                            this.props.rowStyle.paddingUnit === "%"
                              ? "percent"
                              : "pixel"
                          }
                          minusClick={() =>
                            this.counterMinus(
                              this.props.rowStyle &&
                                this.props.rowStyle.paddingTopMobile
                                ? this.props.rowStyle.paddingTopMobile
                                : "0",
                              "paddingTopMobile"
                            )
                          }
                          valueContent={
                            this.props.rowStyle &&
                            this.props.rowStyle.paddingTopMobile
                              ? this.props.rowStyle.paddingTopMobile
                              : "0"
                          }
                          disabled={false}
                          onChange={(e) => {
                            this.counterChange(e, "paddingTopMobile");
                          }}
                          plusClick={() => {
                            this.counterPlus(
                              this.props.rowStyle &&
                                this.props.rowStyle.paddingTopMobile
                                ? this.props.rowStyle.paddingTopMobile
                                : "0",
                              "paddingTopMobile"
                            );
                          }}
                        />
                      </div>
                      <div className="d-block">
                        <Counter
                          label="Bottom"
                          small={
                            this.props.rowStyle &&
                            this.props.rowStyle.paddingUnit === "%"
                              ? "percent"
                              : "pixel"
                          }
                          minusClick={() =>
                            this.counterMinus(
                              this.props.rowStyle &&
                                this.props.rowStyle.paddingBottomMobile
                                ? this.props.rowStyle.paddingBottomMobile
                                : "0",
                              "paddingBottomMobile"
                            )
                          }
                          valueContent={
                            this.props.rowStyle &&
                            this.props.rowStyle.paddingBottomMobile
                              ? this.props.rowStyle.paddingBottomMobile
                              : "0"
                          }
                          disabled={false}
                          onChange={(e) => {
                            this.counterChange(e, "paddingBottomMobile");
                          }}
                          plusClick={() =>
                            this.counterPlus(
                              this.props.rowStyle &&
                                this.props.rowStyle.paddingBottomMobile
                                ? this.props.rowStyle.paddingBottomMobile
                                : "0",
                              "paddingBottomMobile"
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="padding-section"
                style={{ marginTop: "20px", marginBottom: "20px" }}
              >
                <div className="heading">Border</div>
              </div>
              <div
                style={{ display: "flex", flexDirection: "row" }}
                className="modalContentWrapper"
              >
                <div id={this.props.ID}>
                  <Counter
                    label="Border Width"
                    minusClick={() =>
                      this.counterMinus(this.props.borderWidth, "borderWidth")
                    }
                    valueContent={this.props.borderWidth}
                    disabled={false}
                    onChange={(e) => {
                      this.counterChange(e, "borderWidth");
                    }}
                    plusClick={() =>
                      this.counterPlus(this.props.borderWidth, "borderWidth")
                    }
                  />
                </div>
                <div
                  style={{
                    marginLeft: "20px",
                    marginTop: "20px",
                    width: "300px",
                  }}
                >
                  <ColorPicker
                    btnLabel="Border Color"
                    colorValue={this.props.rowBorderColor}
                    colorDefaultValue={{ r: 252, g: 252, b: 252, a: 0 }}
                    getColor={(e) => {
                      this.bgColorhandleChange(e, "rowBorderColor");
                    }}
                  />
                </div>
              </div>
            </React.Fragment>
          )}

          <div className="clearfix"></div>
          <div
            className="padding-section"
            style={{ marginTop: "10px", marginBottom: "20px" }}
          >
            <div className="heading">Background</div>
          </div>
          <div
            className="modalContentWrapper"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div style={{ width: "300px" }}>
              {" "}
              <ColorPicker
                btnLabel="Row Background Color"
                colorValue={this.props.rowBgColor}
                colorDefaultValue={{ r: 252, g: 252, b: 252, a: 1 }}
                getColor={(e) => {
                  this.bgColorhandleChange(e, "rowBgColor");
                }}
              />
            </div>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <button
                className="select-various-content-button"
                onClick={this.addBg}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17.8"
                  height="17.8"
                  viewBox="0 0 17.8 17.8"
                >
                  <g id="image" transform="translate(-0.6 -2.1)">
                    <rect
                      id="Rectangle_733"
                      data-name="Rectangle 733"
                      width="16"
                      height="16"
                      rx="2"
                      transform="translate(1.5 3)"
                      fill="none"
                      stroke="#0c3254"
                      strokeLinecap="square"
                      strokeWidth="1.8"
                    />
                    <circle
                      id="Ellipse_10"
                      data-name="Ellipse 10"
                      cx="1.5"
                      cy="1.5"
                      r="1.5"
                      transform="translate(4.467 6.467)"
                      fill="none"
                      stroke="#0c3254"
                      strokeLinecap="square"
                      strokeWidth="1.8"
                    />
                    <path
                      id="Path_348"
                      data-name="Path 348"
                      d="M18.4,14.5,14.537,10,4,20"
                      transform="translate(-2 -2)"
                      fill="none"
                      stroke="#0c3254"
                      strokeLinecap="square"
                      strokeWidth="1.8"
                    />
                  </g>
                </svg>
                {this.props.rowCroppedBg || this.props.rowBg ? "Change" : "Add"}{" "}
                Row Background Image
              </button>
              {this.props.rowBg ? (
                <Fragment>
                  <button
                    onClick={() => {
                      this.setState({
                        toggleBackgroundSettings:
                          !this.state.toggleBackgroundSettings,
                      });
                    }}
                    className={
                      "deleteBackgroundIcon settingBackground " +
                      (this.state.toggleBackgroundSettings ? " active" : " ")
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="19.455"
                      height="20.001"
                      viewBox="0 0 19.455 20.001"
                    >
                      <path
                        id="Icon"
                        d="M216,440h-4a.488.488,0,0,1-.49-.42l-.38-2.65a7.376,7.376,0,0,1-1.69-.98l-2.49,1a.467.467,0,0,1-.169.03.5.5,0,0,1-.44-.25l-2-3.46a.5.5,0,0,1,.121-.64l2.11-1.65a8.111,8.111,0,0,1-.07-.98,7.937,7.937,0,0,1,.07-.98l-2.11-1.651a.491.491,0,0,1-.121-.64l2-3.46a.492.492,0,0,1,.429-.25.569.569,0,0,1,.18.03l2.49,1a7.645,7.645,0,0,1,1.69-.979l.38-2.65A.488.488,0,0,1,212,420h4a.488.488,0,0,1,.49.42l.381,2.651a7.361,7.361,0,0,1,1.689.979l2.49-1a.471.471,0,0,1,.17-.03.5.5,0,0,1,.44.25l2,3.46a.5.5,0,0,1-.12.64l-2.111,1.651a6.876,6.876,0,0,1,0,1.96l2.111,1.65a.5.5,0,0,1,.12.64l-2,3.46a.493.493,0,0,1-.43.25.57.57,0,0,1-.18-.03l-2.49-1a7.634,7.634,0,0,1-1.689.98l-.381,2.65A.488.488,0,0,1,216,440Zm-6.25-6.32h0l.91.7a5.669,5.669,0,0,0,1.229.71l1.06.43.16,1.13L213.3,438h1.4l.2-1.351.16-1.13,1.059-.43a5.836,5.836,0,0,0,1.25-.73l.9-.68,1.04.419,1.27.51.7-1.211-1.08-.84-.89-.7.139-1.13c.029-.281.05-.513.05-.73a5.236,5.236,0,0,0-.05-.73l-.139-1.13.89-.7,1.069-.85-.7-1.211-1.27.51-1.06.43-.91-.7a5.681,5.681,0,0,0-1.23-.71l-1.06-.43-.16-1.13-.19-1.35H213.3l-.2,1.35-.16,1.13-1.06.43a5.853,5.853,0,0,0-1.25.73l-.9.68-1.04-.42-1.27-.51-.7,1.211,1.08.84.89.7-.14,1.13c-.031.316-.049.537-.049.73s.021.446.049.74l.14,1.13-.89.7-1.08.841.7,1.21,1.27-.51,1.059-.429ZM214,434a4,4,0,1,1,4-4A4,4,0,0,1,214,434Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,214,428Z"
                        transform="translate(-204.271 -419.999)"
                        fill="#0c3254"
                      />
                    </svg>
                  </button>
                  <button
                    onClick={this.resetBackground}
                    className="deleteBackgroundIcon"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g id="delete" transform="translate(34.5 5.5)">
                        <g id="trash" transform="translate(-32.5 -3.5)">
                          <path
                            id="Path_363"
                            data-name="Path 363"
                            d="M3,6H16.539"
                            transform="translate(0 -0.991)"
                            fill="none"
                            stroke="#0c3254"
                            strokeLinecap="square"
                            strokeWidth="1.3"
                          />
                          <path
                            id="Path_364"
                            data-name="Path 364"
                            d="M15.53,5.009v10.53a1.5,1.5,0,0,1-1.5,1.5H6.5a1.5,1.5,0,0,1-1.5-1.5V5.009m2.257,0V3.5A1.5,1.5,0,0,1,8.761,2H11.77a1.5,1.5,0,0,1,1.5,1.5v1.5"
                            transform="translate(-0.496)"
                            fill="none"
                            stroke="#0c3254"
                            strokeLinecap="square"
                            strokeWidth="1.3"
                          />
                          <line
                            id="Line_64"
                            data-name="Line 64"
                            y2="4.513"
                            transform="translate(8.265 8.77)"
                            fill="none"
                            stroke="#0c3254"
                            strokeLinecap="square"
                            strokeWidth="1.3"
                          />
                          <line
                            id="Line_65"
                            data-name="Line 65"
                            y2="4.513"
                            transform="translate(11.274 8.77)"
                            fill="none"
                            stroke="#0c3254"
                            strokeLinecap="square"
                            strokeWidth="1.3"
                          />
                        </g>
                      </g>
                    </svg>
                  </button>
                </Fragment>
              ) : null}
            </div>
          </div>

          <div className="clearfix"></div>

          {this.state.toggleBackgroundSettings ? (
            <div className="modalContentWrapper">
              <div className="selectedRowThumbnail">
                <img
                  style={{
                    marginTop: "20px",
                    marginBottom: "20px",
                    width: "300px",
                    height: "auto",
                    boxShadow: "0 0 10px 0px #0078ff",
                    border: "solid 1px #0078ff",
                  }}
                  src={
                    this.props.rowCroppedBg
                      ? this.props.rowCroppedBg
                      : this.props.rowBg
                  }
                />
              </div>

              <div className="row backgroundImageProperties columnCropBg">
                <div className="col-sm-6 bgRepeatWrapper">
                  <label>Background Repeat</label>
                  <div className="radiusToggle">
                    <input
                      onChange={this.bgRepeat}
                      type="checkbox"
                      id="switch"
                      checked={this.props.bgRepeat == "repeat"}
                    />
                  </div>
                  <span>{this.props.bgRepeat}</span>
                </div>
                <div className="col-sm-6 bgRepeatWrapper">
                  <label>Background Size</label>
                  <div className="radiusToggle">
                    <input
                      onChange={this.bgSize}
                      type="checkbox"
                      id="size"
                      checked={this.props.bgSize == "cover"}
                    />
                  </div>
                  <span>{this.props.bgSize}</span>
                </div>
                <div className="col-sm-12 bgRepeatWrapper">
                  <label>Background Opacity</label>
                  <div className="rangeWidthSlider rowBgRange">
                    <RangeInputSlider
                      onChangeHandler={(widthVal) => {
                        this.rangeWidthSlider(widthVal);
                      }}
                      widthValue={this.props.rowOpacity}
                      maxWidthRange={1.0}
                      step={0.1}
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
          {this.state.clickedID === this.props.ID &&
          this.state.cropImage == null ? (
            <div className="libraryContent selectVideo modalContentWrapper">
              <TabContent>
                <TabPane>
                  <ImagesContent
                    userID={this.props.userID}
                    sessionID={this.props.sessionID}
                    modalUpload={this.props.modalUpload}
                    ID={this.props.ID}
                    chooseImageForParent={this.selectImage}
                    forParentContent={true}
                    selectingContent={true}
                    closeImageLibrary={() => {
                      this.setState({ ...this.state, clickedID: null });
                    }}
                    initP={this.props.initP}
                    addImage={this.props.addImage}
                    opacity={this.props.opacity}
                    radius={this.props.radius}
                    float={this.props.float}
                  />
                </TabPane>
              </TabContent>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    layout: state.present.layout,
    layoutTitle: state.present.layoutTitle,
    preset: state.present.preset,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(RowBg);
